import React from 'react';
import './ChatbotLoader.scss';
import logoDarkTheme from '../../assets/vivvy-logo.png';

const ChatbotLoader: React.FC = () => {
  return (
    <div className="chatbot-loader-overlay">
      {/* Floating Particles */}
      <div className="floating-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>
      
      {/* Main Loader Content */}
      <div className="chatbot-loader-content">
        <img src={logoDarkTheme} alt="Vivvy Logo" className="chatbot-loader-logo" />
        <div className="chatbot-loader-spinner"></div>
        <p className="chatbot-loader-text">
          Powered by <a href="https://vivvy.ai" target="_blank" rel="noopener noreferrer">Vivvy.ai</a>
        </p>
      </div>
    </div>
  );
};

export default ChatbotLoader;